<div mat-dialog-title>
    <span>
        Selected Students
    </span>
</div>

<mat-dialog-content>
    <div class="flex-content">
        <mat-table style="width: 100%;" matSort matSortActive="fullName" [dataSource]="angularMatData" class="mat-elevation-z0">

            <!-- Student Number -->
            <ng-container matColumnDef="StudentNumber">
                <mat-header-cell mat-sort-header *matHeaderCellDef>
                    <span>Student #</span>
                    <filter class="mat-filter" [data]="angularMatData" columnName="StudentNumber" dataType="string"></filter>
                </mat-header-cell>
                <mat-cell *matCellDef="let student">{{student.StudentNumber}}</mat-cell>
            </ng-container>

            <!-- Student Name -->
            <ng-container matColumnDef="fullName">
                <mat-header-cell mat-sort-header *matHeaderCellDef>
                    <span>Student Name</span>
                    <filter class="mat-filter" [data]="angularMatData" columnName="fullName" dataType="string"></filter>
                </mat-header-cell>
                <mat-cell *matCellDef="let student">
                    {{student.fullName}}
                </mat-cell>
            </ng-container>

            <!-- Enrollment Status -->
            <ng-container matColumnDef="EnrollmentStatus">
                <mat-header-cell mat-sort-header *matHeaderCellDef>
                    <span>Status</span>
                    <filter class="mat-filter" [data]="angularMatData" columnName="EnrollmentStatus" dataType="string"></filter>
                </mat-header-cell>
                <mat-cell *matCellDef="let student">{{student.EnrollmentStatus}}</mat-cell>
            </ng-container>

            <!-- Grade -->
            <ng-container matColumnDef="Grade">
                <mat-header-cell mat-sort-header *matHeaderCellDef>
                    <span>Grade</span>
                    <filter class="mat-filter" [data]="angularMatData" columnName="Grade" dataType="number"></filter>
                </mat-header-cell>
                <mat-cell *matCellDef="let student">{{student.Grade}}</mat-cell>
            </ng-container>

            <!-- School -->
            <ng-container matColumnDef="EnrollmentSchool">
                <mat-header-cell mat-sort-header *matHeaderCellDef>
                    <span>School</span>
                    <filter class="mat-filter" [data]="angularMatData" columnName="EnrollmentSchool" dataType="string"></filter>
                </mat-header-cell>
                <mat-cell *matCellDef="let student">{{student.EnrollmentSchool}}</mat-cell>
            </ng-container>

            <mat-header-row *matHeaderRowDef="displayedColumns; sticky: false"></mat-header-row>
            <!-- Data rows -->
            <mat-row matRipple *matRowDef="let row; columns: displayedColumns; let i = index;" style="padding:0;overflow: hidden;">
            </mat-row>
        </mat-table>
    </div>
    <div>
        <mat-paginator [showFirstLastButtons]="true"
                       [pageSize]="50"
                       [pageSizeOptions]="[10, 50, 100]">
        </mat-paginator>
    </div>
</mat-dialog-content>

<mat-dialog-actions>
    <div class="flex-footer-left">
        <tyl-button image="startover.png" label="Clear" (clickEvent)="closeClick('ClearStudents')" translate>
        </tyl-button>
    </div>
    <div class="flex-footer-right">
        <tyl-button id="scaleCancelButton" image="cancel.png" label="Close" (clickEvent)="closeClick('Close')">
        </tyl-button>
    </div>
</mat-dialog-actions>
